export default {
  shuzhi:{
    name:'数智社区',
    title: '数智社区管理平台',
    aTitle: '数智社区居民委员会',
    longitude: '113.1375358933126',
    latitude: '23.031367436947427',
    longitudeBD09: '113.149448',
    latitudeBD09: '23.035010',
    address: '广东省佛山市南海区',
    loginLogo: '@/assets/images/login/login_logo.png',
    loginImg: '@/assets/images/login/login_img.png',
    topLogo: '@/assets/images/login/top_logo.png',
    favicon: '/favicon2.ico',
    isRegisterMode:true,//是否需要注册用户
    houseAddress:'',//房屋登记中的地址固化前缀
    isUseWatermark: false,
    technicalSupportName: '蠢材科技',
    icpName: '粤ICP备2023046542号-1'
  },
  pingdi: {
    name:'平地数智社区',
    title: '平地数智社区管理平台',
    aTitle: '平地社区居民委员会',
    longitude: '113.15204755935986',
    latitude: '23.11538612190888',
    longitudeBD09: '113.163916',
    latitudeBD09: '23.119164',
    address: '广东省佛山市南海区平安路3号',
    loginLogo: '@/assets/images/login/pingdi/login_logo.png',
    loginImg: '@/assets/images/login/pingdi/login_img.png',
    topLogo: '@/assets/images/login/pingdi/top_logo.png',
    favicon: '/favicon.ico',
    isRegisterMode:true,//是否需要注册用户
    houseAddress:'佛山市南海区大沥镇平地',
    isUseWatermark: false,
    technicalSupportName: '蠢材科技',
    icpName: '粤ICP备2023046542号-1'
  },
  shiken: {
    name:'石𬒔数智社区',
    title: '石𬒔数智社区管理平台',
    aTitle: '石𬒔社区居民委员会',
    longitude: '113.15092285312282',
    latitude: '23.011088125167475',
    longitudeBD09: '113.16278',
    latitudeBD09: '23.014819',
    address: '广东省佛山市南海区教育路1号石𬒔社区',
    loginLogo: '@/assets/images/login/shiken/login_logo.png',
    loginImg: '@/assets/images/login/login_img.png',//公用图片
    topLogo: '@/assets/images/login/shiken/top_logo.png',
    favicon: '/favicon2.ico',
    isRegisterMode:false,//是否需要注册用户
    defaultPassword:'shiken123',//(不需要注册用户的默认密码)一定要结合isRegisterMode:false配置
    houseAddress:'佛山市南海区桂城街道石𬒔',
    isUseWatermark: false,
    technicalSupportName: '蠢材科技',
    icpName: '粤ICP备2023046542号-1'
  },
  linyue: {
    name:'林岳数智社区',
    title: '林岳数智社区管理平台',
    aTitle: '林岳社区居民委员会',
    longitude: '113.22912689179223',
    latitude: '22.997687606134086',
    longitudeBD09: '113.240985',
    latitudeBD09: '23.000710',
    address: '广东省佛山市南海区林岳大道北100米林岳社区',
    loginLogo: '@/assets/images/login/linyue/login_logo.png',
    loginImg: '@/assets/images/login/login_img.png',//公用图片
    topLogo: '@/assets/images/login/linyue/top_logo.png',
    favicon: '/favicon2.ico',
    isRegisterMode:true,//是否需要注册用户
    defaultPassword:'linyue123',//(不需要注册用户的默认密码)一定要结合isRegisterMode:false配置
    houseAddress:'佛山市南海区桂城街道林岳',
    isUseWatermark: false,
    technicalSupportName: '蠢材科技',
    icpName: '粤ICP备2024241277号-1'
  },
  taiping: {
    name:'太平数智社区',
    title: '太平数智社区管理平台',
    aTitle: '太平社区居民委员会',
    longitude: '113.09606142715074',
    latitude: '23.107288470129763',
    longitudeBD09: '113.108121',
    latitudeBD09: '23.110444',
    address: '广东省佛山南海区太平大道1号',
    loginLogo: '@/assets/images/login/taiping/login_logo.png',
    loginImg: '@/assets/images/login/login_img.png',//公用图片
    topLogo: '@/assets/images/login/taiping/top_logo.png',
    favicon: '/favicon2.ico',
    isRegisterMode:true,//是否需要注册用户
    defaultPassword:'taiping123',//(不需要注册用户的默认密码)一定要结合isRegisterMode:false配置
    houseAddress:'佛山市南海区大沥镇太平',
    isUseWatermark: true,
    technicalSupportName: '金点科技',
    icpName: '粤ICP备2024331471号-1'
  }
}